import { render } from "./pricetable.vue?vue&type=template&id=5345f351&scoped=true"
import script from "./pricetable.vue?vue&type=script&lang=js"
export * from "./pricetable.vue?vue&type=script&lang=js"

import "./pricetable.vue?vue&type=style&index=0&id=5345f351&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5345f351"],['__file',"src/js/components/pricetable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5345f351"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5345f351', __exports__)) {
    api.reload('5345f351', __exports__)
  }
  
  module.hot.accept("./pricetable.vue?vue&type=template&id=5345f351&scoped=true", () => {
    api.rerender('5345f351', render)
  })

}


export default __exports__